import ufeApi from 'services/api/ufeApi';
import userUtils from 'utils/User';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Basket+Details+API

function getBasketDetails() {
    const url = '/api/shopping-cart/basket';

    return ufeApi
        .makeRequest(url, { headers: userUtils.insertSAZipCodeSACountryCodeHeaders({}), method: 'GET' })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getBasketDetails;
